import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IRoom } from "../roomModel";

export const getAllRooms = createAsyncThunk("Room/FindAllRoom", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Room/FindAllRoom`,
      {
        RoomTitle: "",
      },
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Rooms:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createRoom = createAsyncThunk(
  "Room/InsertRoom",
  async (RoomData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/InsertRoom`,
        RoomData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Room :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateRoom = createAsyncThunk(
  "Room/UpdateRoom",
  async (RoomData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/UpdateRoom`,
        RoomData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Room:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteRoom = createAsyncThunk(
  "Room/DeleteRoom",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/DeleteRoom`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Room :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getRoomByID = createAsyncThunk(
  "Room/FindByIDRoom",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/FindByIDRoom`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        IsActive: result.IsActive ? 1 : 2,
        RoomTitle: result?.RoomTitle ?? "",
        RoomURL: result?.RoomURL ?? "",
        BookingURL: result?.BookingURL ?? "",
        RoomDescription: result?.RoomDescription ?? "",
        Rates: result?.Rates ?? 0,
        Roomsize: result?.Roomsize ?? "",
        Occupancy: result?.Occupancy ?? "",
        RoomView: result?.RoomView ?? "",
        BedType: result?.BedType ?? "",
        RoomHighlights: result?.RoomHighlights ?? "",
        FacilityIDs: result?.FacilityIDs
          ? result?.FacilityIDs?.split(",")?.map((f: number) => +f)
          : [],
        MetaTitle: result?.MetaTitle ?? "",
        MetaKeywords: result?.MetaKeywords ?? "",
        MetaDescription: result?.MetaDescription ?? "",
        SequenceNo: result?.SequenceNo ?? null,
        Images: result?.Images || "",
        RoomInnerimage: result?.RoomInnerimage || [],
        RoomFacilities: result?.RoomFacilities || [],
      } as IRoom;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Room :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveRooms = createAsyncThunk(
  "Room/FindAllActiveRoom",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Room/FindAllActiveRoom`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Rooms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveRoom = createAsyncThunk(
  "Room/ActiveInActiveRoom",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/ActiveInActiveRoom`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Room :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const RoomImageUpload = createAsyncThunk(
  "Room/RoomImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/RoomImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Room Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteRoomImage = createAsyncThunk(
  "Room/DeleteRoomGalleryImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Room/DeleteRoomGalleryImage`,
        { ID: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting room image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
